import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { Container } from "reactstrap"
import { Card, CardBody, Col, Row, Button, Input } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"
import TableContainerWithModal from "components/Common/TableContainerWithModal"
import {
  DateCell,
  TextCell,
  TextToUpperCase,
} from "pages/CreditLog/creditLogCol"
import { IdCell } from "pages/AllDiplomaList/diplomaListCol"
import { StatusCell } from "pages/OrganizationList/organizationLogCol"
import {
  listOrgDiplomas,
  readDiplomaReport,
  readMyOrgCredit,
} from "helpers/api_helper"

const DiplomaList = props => {
  //meta title
  document.title = "Диплом жагсаалт | Diplom.mn"

  const [apiData, setApiData] = useState(null)
  const [diplomaReportData, setDiplomaReportData] = useState(null)
  const [orgData, setOrgData] = useState(null)
  const [bookmark, setBookmark] = useState("")
  const [bookmarkHistory, setBookmarkHistory] = useState([])
  const [currentBookmarkIndex, setCurrentBookmarkIndex] = useState(-1)
  const [loading, setLoading] = useState(false)
  const [isLastPage, setIsLastPage] = useState(false)
  const [pageSize, setPageSize] = useState(10)
  
  // Handle page size change
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10)
    // Reset pagination when page size changes
    setBookmark("")
    setBookmarkHistory([""])
    setCurrentBookmarkIndex(0)
    setIsLastPage(false)
    // Update pageSize - the useEffect will trigger the API call
    setPageSize(newSize)
    // No need to call fetchOrgDiplomas here as it will be triggered by the useEffect
  }
  
  const fetchOrgDiplomas = async (bookmarkValue = "", size = pageSize) => {
    try {
      setLoading(true)
      console.log("Fetching with page size:", size); // Debug log
      
      // Convert size to string as the API expects string parameters
      const r = await listOrgDiplomas(size.toString(), bookmarkValue)
      if (r?.message != "error") {
        setApiData(r.records)
        
        if (
          (r.bookMark === bookmark && bookmark !== "") || 
          !r.bookMark || 
          (r.records && r.records.length === 0)
        ) {
          setIsLastPage(true)
        } else {
          setIsLastPage(false)
          setBookmark(r.bookMark)
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      setIsLastPage(true) // Assume we're at the last page if there's an error
      return "error"
    }
  }

  const handleNextPage = () => {
    if (bookmark && !loading && !isLastPage) {
      // Add current bookmark to history if not already at the end
      if (currentBookmarkIndex === bookmarkHistory.length - 1) {
        setBookmarkHistory([...bookmarkHistory, bookmark])
        setCurrentBookmarkIndex(currentBookmarkIndex + 1)
      } else {
        // We're somewhere in the middle of history, so move forward
        setCurrentBookmarkIndex(currentBookmarkIndex + 1)
      }
      fetchOrgDiplomas(bookmark)
    }
  }

  const handlePrevPage = () => {
    if (currentBookmarkIndex > 0 && !loading) {
      const prevIndex = currentBookmarkIndex - 1
      const prevBookmark = bookmarkHistory[prevIndex] || ""
      setCurrentBookmarkIndex(prevIndex)
      setIsLastPage(false) // Reset last page flag when going back
      fetchOrgDiplomas(prevBookmark)
    }
  }

  const fetchDiplomaReport = async () => {
    try {
      const r = await readDiplomaReport()
      const err = r
      if (err?.message != "error") {
        setDiplomaReportData(r)
      }
    } catch (error) {
      return "error"
    }
  }
  const fetchMyOrg = async () => {
    try {
      const r = await readMyOrgCredit()
      const err = r
      if (err?.message != "error") {
        setOrgData(r)
      }
    } catch (error) {
      return "error"
    }
  }
  useEffect(() => {
    fetchMyOrg()
    fetchDiplomaReport()
    
    // Initial fetch with empty bookmark
    fetchOrgDiplomas()
    // Initialize bookmark history with empty string for the first page
    setBookmarkHistory([""])
    setCurrentBookmarkIndex(0)
    setIsLastPage(false)
  }, []) // Initial load effect
  
  // Add a separate effect that triggers when pageSize changes
  useEffect(() => {
    // Only run after initial render
    if (currentBookmarkIndex !== -1) {
      console.log("Page size changed to:", pageSize);
      fetchOrgDiplomas("", pageSize);
    }
  }, [pageSize]);
  
  const [modal1, setModal1] = useState(false)

  const toggleViewModal = () => setModal1(!modal1)
  const columns = useMemo(
    () => [
      {
        Header: "Өдөр",
        accessor: "createTxTimestamp",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <DateCell {...cellProps} />
        },
      },
      {
        Header: "ID",
        accessor: "id",
        filterable: false,
        disableFilters: true,
        Cell: cellProps => {
          return <IdCell {...cellProps} />
        },
      },
      {
        Header: "Дипломын дугаар",
        accessor: "claims.diplomaNumber",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <TextToUpperCase {...cellProps} />
        },
      },
      {
        Header: "Нэр",
        accessor: "claims.extras.hemisDiploma.FIRST_NAME",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <TextCell {...cellProps} />
        },
      },
      {
        Header: "Статус",
        accessor: "status",
        disableFilters: true,
        filterable: false,
        Cell: cellProps => {
          return <StatusCell {...cellProps} />
        },
      },
    ],
    []
  )
  
  // Custom pagination component
  const CustomPagination = () => {
    return (
      <Row className="justify-content-between align-items-center mt-3">
        <Col sm="auto">
          <div className="d-flex align-items-center">
            <label className="me-2 mb-0">Хуудасны хэмжээ:</label>
            <Input
              type="select"
              value={pageSize}
              onChange={handlePageSizeChange}
              style={{ width: '80px' }}
              className="form-select"
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Input>
          </div>
        </Col>
        <Col sm="auto">
          <div className="d-flex">
            <Button
              color="primary"
              className="me-2"
              onClick={handlePrevPage}
              disabled={currentBookmarkIndex <= 0 || loading}
            >
              <i className="mdi mdi-chevron-left me-1"></i>
              Өмнөх
            </Button>
            <Button
              color="primary"
              onClick={handleNextPage}
              disabled={!bookmark || loading || isLastPage}
            >
              Дараах
              <i className="mdi mdi-chevron-right ms-1"></i>
            </Button>
          </div>
        </Col>
      </Row>
    )
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("НҮҮР")}
            breadcrumbItem={props.t("Хянах самбар")}
          />
          <Row>
            <Col>
              <Row>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Нийт оруулсан</p>
                          <h4 className="mb-0">
                            {diplomaReportData != null ? (
                              diplomaReportData.totalCount
                            ) : (
                              <></>
                            )}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className={"bx bx-archive-in font-size-24"}></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">
                            Нийт хүлээгдэж буй
                          </p>
                          <h4 className="mb-0">
                            {diplomaReportData &&
                            diplomaReportData.statusCount >= 1
                              ? diplomaReportData.statusCount[0].count
                              : null}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i className={"bx bx-copy-alt  font-size-24"}></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="4">
                  <Card className="mini-stats-wid">
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <p className="text-muted fw-medium">Нийт кредит</p>
                          <h4 className="mb-0">
                            {orgData != null ? orgData.amount : null}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle bg-primary">
                            <i
                              className={"bx bx-purchase-tag-alt font-size-24"}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Card>
                <CardBody>
                  <div className="mb-4 h4 card-title">
                    Хамгийн сүүлд оруулсан
                  </div>
                  <TableContainerWithModal
                    key={`table-${pageSize}`} // Add key to force re-render when page size changes
                    columns={columns}
                    data={apiData ? apiData : []}
                    isGlobalFilter={true}
                    isShowingPageLength={false}
                    isPagination={false} /* Turn off built-in pagination */
                    iscustomPageSizeOptions={false} /* We'll handle page size ourselves */
                    customPageSize={pageSize}
                    pagination="pagination pagination-rounded justify-content-end mb-2"
                    isUpload={false}
                    modalState={modal1}
                    toggleViewModal={toggleViewModal}
                  />
                  {/* Use custom pagination component */}
                  <CustomPagination />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

DiplomaList.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(DiplomaList)
